import DefaultValidation from "@/services/validations/DefaultValidation";

export default class GradeValidation extends DefaultValidation{
    validate(model) {
        let validated = true;

        model += "";

        model = model.trim();

        if (model===null||model==='') {
            validated = false;
        }

        return validated;
    }
}